import { useEffect, useState } from "react";

import { Typography, makeStyles, Grid } from "@material-ui/core";

import { IconLabelButton } from "./IconLabelButton";
import { COLORS } from "../../../../theme/colors";
import { VerticalDivider } from "../../../../components/base";
import AssetsIcon from "../../../../assets/images/icons/nav/assets.svg";
import { getData } from "../../../../services";

const ENDPOINT = "/praas/v1/power-assets/recommendations/";

const useStyles = makeStyles(() => ({
  root: {
    paddingRight: "32px",
  },
  label: {
    lineHeight: "24px",
    letterSpacing: "0.1px",
    textTransform: "capitalize",
    fontWeight: "bold",
    paddingTop: "16px",
  },
}));

export const InstalledAssetsRecommendations = () => {
  const classes = useStyles();
  const [data, setData] = useState({});

  useEffect(() => {
    getData(ENDPOINT, (data) => {
      setData(data);
    });
  }, []);

  return (
    <Grid container wrap="nowrap" spacing={4} className={classes.root}>
      <Grid item>
        <VerticalDivider height="128px" color={COLORS.blacks[10]} />
      </Grid>
      <Grid container item direction="column" spacing={1}>
        <Grid item>
          <Typography variant="h5" className={classes.label}>
            Recommendations
          </Typography>
        </Grid>
        <Grid item>
          <IconLabelButton iconSrc={AssetsIcon} height={52}>
            Approve New Power Assetes ({data.new?.count || 0})
          </IconLabelButton>
        </Grid>
      </Grid>
    </Grid>
  );
};
